import { render, staticRenderFns } from "./webrtc_result.vue?vue&type=template&id=448ce836&scoped=true"
import script from "./webrtc_result.vue?vue&type=script&lang=js"
export * from "./webrtc_result.vue?vue&type=script&lang=js"
import style0 from "./webrtc_result.vue?vue&type=style&index=0&id=448ce836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ce836",
  null
  
)

export default component.exports